import React from 'react'
import classnames from 'classnames'
import format from 'date-fns/format'
import InfoIcon from './info.svg'
import styles from './styles.css'

interface PreorderInfoProps {
  availableAt?: Date
  wrapperClassName?: string
}

const PreOrderInfo: React.FC<PreorderInfoProps> = ({ availableAt, wrapperClassName }) => {
  if (!availableAt) return null
  return (
    <div className={classnames(styles.preorder, wrapperClassName)}>
      <InfoIcon height={24} width={24} className={styles.infoIcon} />
      <span className={styles.bold}>Pre-order</span>: Ships on {format(availableAt, 'MMMM d, y')}
    </div>
  )
}

export default PreOrderInfo
